import MyScriptText from '@/api/external/MyScriptText'

/**
 * 手書き入力変換-英語
 */
export default class MyScriptEnglish extends MyScriptText {
  /**
   * コンストラクタ
   */
  constructor() {
    super()
    // 変換先言語
    this.lang = 'en_US'
  }
}
